/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M2 2.0425C2 .9145 2.8954 0 4 0h16c1.1046 0 2 .9145 2 2.0425v19.9149C22 23.0855 21.1046 24 20 24H4c-1.1046 0-2-.9145-2-2.0426V2.0425Zm2-.5106h16c.2761 0 .5.2286.5.5106V5.617h-17V2.0425c0-.282.2239-.5106.5-.5106ZM3.5 18.383v3.5744c0 .2821.2239.5107.5.5107h16c.2761 0 .5-.2286.5-.5107V18.383h-17Zm17-1.5319h-17V12.766h17v4.0851Zm0-9.7022v4.0851h-17V7.149h17Z"
    clipRule="evenodd"
  />,
  'MenuAccessLogs'
);
